import { httpGet, httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { IProductKitItem } from '~/types/product/models'

export const apiEntityPath = '/api/productkititems'

export async function getProductKitItems({ apiPath = apiEntityPath } = {}) {
  const callingMn = getProductKitItems.name
  return httpGet<IProductKitItem[]>({
    callingMn,
    apiPath,
  })
}

export async function createProductKitItem(entity: IProductKitItem) {
  const callingMn = createProductKitItem.name
  const apiPath = apiEntityPath
  return httpPost<IProductKitItem>({ callingMn, apiPath, entity })
}

export async function updateProductKitItem(
  entityData: Partial<IProductKitItem>,
  id: TEntityId
) {
  const callingMn = updateProductKitItem.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialIProductKitItem = Partial<IProductKitItem>
  return httpPatchMerge<TPartialIProductKitItem>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteProductKitItem(entityData: IProductKitItem) {
  const callingMn = deleteProductKitItem.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
